var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgPhonelink = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{fill:#005ca5;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,0H24V24H0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M19,1H9A2.006,2.006,0,0,0,7,3V6H9V4H19V20H9V18H7v3a2.006,2.006,0,0,0,2,2H19a2.006,2.006,0,0,0,2-2V3A2.006,2.006,0,0,0,19,1ZM10.8,11V9.5A2.746,2.746,0,0,0,8,7,2.746,2.746,0,0,0,5.2,9.5V11A1.29,1.29,0,0,0,4,12.2v3.5A1.309,1.309,0,0,0,5.2,17h5.5A1.309,1.309,0,0,0,12,15.8V12.3A1.309,1.309,0,0,0,10.8,11ZM9.5,11h-3V9.5A1.375,1.375,0,0,1,8,8.2,1.375,1.375,0,0,1,9.5,9.5Z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPhonelink, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/phonelink.e5d3a492.svg";
export { ForwardRef as ReactComponent };